import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  DPD pakirobot

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  Терминал CollectNet
*/
/* @__NO_SIDE_EFFECTS__ */
const m233 = msg(
  mf`DPD pakirobot`,
  mf``,
  mf`Терминал CollectNet`,
)

export { m233 as 'link.collectnet.alt' }